import { Toast } from "@newsela/angelou";

export const SETTINGS_BASE_PAGE_PROPS = {
  title: "Class directory",
  breadcrumbsLinks: {
    href: "/account/classes/",
    contents: "Class Directory",
  },
  showHeaderSeparator: true,
};

export const EVENT_TOAST_CLASS_SYNCED = {
  showIcon: true,
  statusColor: Toast.statusColor.success,
};

export const EVENT_TOAST_CLASS_CREATED = {
  showIcon: true,
  statusColor: Toast.statusColor.success,
};

export const EVENT_TOAST_ROSTER_CHOICE_FAIL = {
  showIcon: true,
  statusColor: Toast.statusColor.danger,
  children: "Could not connect to the provider",
};

export const PAGE_SIZE = 10;
